module.exports = __webpack_public_path__ + "static/media/blog2Sub.0ab11f4e.jpg";